"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var TabHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n  border-bottom: 2px solid #dddddd;\n  column-gap: 2rem;\n  margin-top: 1.5625rem;\n"], ["\n  display: flex;\n  align-items: flex-end;\n  border-bottom: 2px solid #dddddd;\n  column-gap: 2rem;\n  margin-top: 1.5625rem;\n"])));
var TabTitle = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  font-size: 0.75rem;\n  align-items: center;\n  color: #2362a2;\n  padding-bottom: 14px;\n  font-weight: bold;\n  margin-bottom: -1px;\n  letter-spacing: 0.05em;\n  :hover {\n    border-bottom: 2px solid #3b3b3b;\n    padding-bottom: 12px;\n  }\n\n  ", "\n"], ["\n  cursor: pointer;\n  display: flex;\n  font-size: 0.75rem;\n  align-items: center;\n  color: #2362a2;\n  padding-bottom: 14px;\n  font-weight: bold;\n  margin-bottom: -1px;\n  letter-spacing: 0.05em;\n  :hover {\n    border-bottom: 2px solid #3b3b3b;\n    padding-bottom: 12px;\n  }\n\n  ",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: #3b3b3b;\n      text-decoration: none;\n      border-bottom: 2px solid #3b3b3b;\n      box-sizing: border-box;\n      padding-bottom: 12px;\n    "], ["\n      color: #3b3b3b;\n      text-decoration: none;\n      border-bottom: 2px solid #3b3b3b;\n      box-sizing: border-box;\n      padding-bottom: 12px;\n    "])));
});
var ProfilTabs = function (_a) {
    var activeId = _a.activeId, children = _a.children, onSelect = _a.onSelect;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TabHeader, null, react_1.Children.map(children, function (component) {
            var id = ramda_1.path(['props', 'id'], component);
            var title = ramda_1.path(['props', 'title'], component);
            return (react_1.default.createElement(TabTitle, { isActive: id === activeId, onClick: id ? function () { return onSelect(id); } : undefined }, title));
        })),
        react_1.default.createElement("div", null, react_1.Children.toArray(children).find(ramda_1.pathEq(['props', 'id'], activeId)))));
};
var Tab = function (_a) {
    var id = _a.id, children = _a.children;
    return react_1.default.createElement("div", { "data-testid": id }, children);
};
ProfilTabs.Tab = Tab;
exports.default = ProfilTabs;
var templateObject_1, templateObject_2, templateObject_3;
